export default function (value) {
    return value?.replaceAll(/\n/gi, '<br/>');
}
